<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "Hotel Blocking List",
      items: [
        {
          text: "Hotel",
          href: "/",
        },
        {
          text: "Blocking List",
          active: true,
        },
      ],
      bockLists: [],
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
  mounted() {
    this.getBlockingList();
  },
    computed: {
        filteredList() {
            return this.bockLists.filter(block => {
                return block.uuid.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search=val;
        },

    async deleteWarning(bockList) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(bockList);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getBlockingList() {
        var _this = this;
      try {
        axios
          .get("/api/hotel/block_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              _this.bockLists = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    deleteItem: function deleteItem(bockList) {
      var _this = this;
      axios
        .post("/api/hotel/block_delete/" + bockList.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          if(response.data.status){
              _this.getBlockingList();
              _this.hasDeleted = false;
          } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
          }
        });
    },
  },
};
</script>

<template>
  <Layout   @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Hotel Name</th>
                    <th>Search Blocked</th>
                    <th>Booking Blocked</th>
                    <th>Destination</th>
                      <th>Country Code</th>
                      <th>Account Type</th>
                    <th>Active</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bockList,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{bockList.hotel_name == null ? 'all' : bockList.hotel_name}}</td>
                    <td>{{ bockList.is_search_blocked == 1 ? 'Yes' : 'No' }}</td>
                    <td>{{ bockList.is_booking_blocked == 1 ? 'Yes' : 'No' }}</td>
                      <td>{{ bockList.destination == null ? 'all' :bockList.destination}}</td>
                      <td>{{bockList.country_code == null ? 'all' : bockList.country_code}}</td>
                      <td>{{bockList.user_account_type == null || bockList.user_account_type == 'null' ? 'all' :bockList.user_account_type}}</td>
                    <td>{{ bockList.is_active == 1 ? 'Yes' : 'No' }}</td>
                    <td><router-link :to="{ name: 'hotel_block_update', params: {uuid: bockList.uuid } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(bockList)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
